import type { NodeTree } from "@craftjs/core";

import baseResolvedBlocks from "@/components/editor/base-resolved-blocks";

import type {
  CraftQuery,
  Theme,
  ThemeFactoryOptions,
  ThemeTemplateFactory,
  ThemeTemplateOptions,
} from "../types";

export const createThemeRegistry = (
  ...themeFactories: ReturnType<typeof createThemeFactory>[]
) => {
  return (opts: ThemeFactoryOptions) =>
    themeFactories.map((themeFactory) => themeFactory(opts));
};

export const createThemeFactory = (
  themeFactory: (opts: ThemeFactoryOptions) => Theme
) => (opts: ThemeFactoryOptions) => {
  const theme = themeFactory(opts);
  return {
    ...theme,
    blocks: {
      ...baseResolvedBlocks,
      ...theme.blocks,
    },
  };
};

export const createThemeTemplateFactory = (
  templateFactory: (options: ThemeTemplateOptions) => JSX.Element[],
  normalize?: (nodeTrees: NodeTree[], query: CraftQuery) => NodeTree[]
): ThemeTemplateFactory => {
  return (options) => {
    const blocks = templateFactory(options);

    const nodeTrees = blocks.map((block) =>
      options.query.parseReactElementAsNodeTree(block)
    );

    return normalize?.(nodeTrees, options.query) ?? nodeTrees;
  };
};
